/* eslint-disable react-hooks/exhaustive-deps */
import L from 'leaflet';
import React, { useEffect, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { useDispatch, useSelector } from 'react-redux';
import { MAX_DELAY_SHOW_WARNING } from '../../constants/system.keys';
import { autoRemoveOldNotifyDeviceOnMaps } from '../../redux/actions';
import { getDiffTimeFromNow } from '../../untils/date';
import WarningDeviceWindow from './WarningDeviceWindow';

export const WarningMarkers = ({ mode, mapRef }) => {
  const dispatch = useDispatch();
  const [listTooltips, setListTooltips] = useState([]);

  const [listWarningMarker, setListWarningMarker] = useState([]);
  const { mapsNotifyDevices } = useSelector((state) => state);

  useEffect(() => {
    if (mode === 0) {
      setListWarningMarker(
        (mapsNotifyDevices || []).filter((item) => {
          if (
            item.deviceType === 'camera' // && getDiffTimeFromNow(item.lastUpdateTime) < SYSTEM.MAX_DELAY_SHOW_WARNING
          ) {
            return true;
          }
          return false;
        })
      );
    }
    if (mode === 1) {
      setListWarningMarker(
        (mapsNotifyDevices || []).filter((item) => {
          if (
            item.deviceType === 'gateway' // && getDiffTimeFromNow(item.lastUpdateTime) < SYSTEM.MAX_DELAY_SHOW_WARNING
          ) {
            return true;
          }
          return false;
        })
      );
    }
  }, [mode, mapsNotifyDevices]);

  useEffect(() => {
    if (mapRef.current) {
      // remove old notify in state
      listTooltips.forEach((item) => {
        if (getDiffTimeFromNow(item.lastUpdateTime) > MAX_DELAY_SHOW_WARNING) {
          item.tooltip.close();
        }
      });

      const results = [];

      listWarningMarker.forEach((mark) => {
        console.log('Enter show tooltip');
        const tooltip = L.tooltip({
          className: 'popup-warning-container',
          permanent: true,
        });
        results.push({ tooltip, lastUpdateTime: new Date().getTime() });

        tooltip
          .setLatLng([mark.lat, mark.lng])
          .setContent(
            ReactDOMServer.renderToString(<WarningDeviceWindow device={mark} />)
          )
          .addTo(mapRef.current.leafletElement);
      });

      setListTooltips([...listTooltips, ...results]);
    }
  }, [listWarningMarker]);

  useEffect(() => {
    let intervalCheckOldNotifyId = setInterval(() => {
      // Clear old notify on store
      dispatch(autoRemoveOldNotifyDeviceOnMaps());
    }, 4000);

    return () => {
      if (intervalCheckOldNotifyId) {
        clearInterval(intervalCheckOldNotifyId);
      }
    };
  }, [dispatch]);

  return null;
};
